import { render, staticRenderFns } from "./AddressBookEditPopup.vue?vue&type=template&id=66b340d8&scoped=true&"
import script from "./AddressBookEditPopup.vue?vue&type=script&lang=js&"
export * from "./AddressBookEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b340d8",
  null
  
)

export default component.exports